import React from 'react';
import { CheckCircleFilled, DeleteFilled, ExclamationCircleFilled, InfoCircleFilled, LikeFilled, ReadFilled, WarningFilled } from '@ant-design/icons';
import * as S from './BaseNotification.styles';
import { BaseSpace } from '../BaseSpace/BaseSpace';

interface Icons {
  info: React.ReactNode;
  success: React.ReactNode;
  warning: React.ReactNode;
  error: React.ReactNode;
  mention: React.ReactNode;
}

export type NotificationType = 'info' | 'mention' | 'success' | 'warning' | 'error';

interface BaseNotificationProps {
  id: number;
  type: NotificationType;
  title: React.ReactNode;
  description?: React.ReactNode;
  mentionIconSrc?: React.ReactNode;
  className?: string;
  showRead?: boolean;
  showDelete?: boolean;
  onRead?: (id: number) => void;
  onDelete?: (id: number) => void;
}

export const BaseNotification: React.FC<BaseNotificationProps> = ({ id, type, mentionIconSrc, title, description, className, showRead, showDelete, onRead, onDelete, ...props }) => {
  const icons: Icons = {
    info: <InfoCircleFilled />,
    success: <CheckCircleFilled />,
    warning: <ExclamationCircleFilled />,
    error: <WarningFilled />,
    mention: mentionIconSrc,
  };

  const icon = icons[type] || icons.warning;

  return (
    <S.SpaceWrapper type={type} align="start" size="middle" className={className} >
      {mentionIconSrc ? <S.NotificationIcon src={icon} alt="User icon" /> : icon}
      <BaseSpace size={1} direction="vertical">
        <S.Title className="title">{title}</S.Title>
        <S.Description>{description}</S.Description>
      </BaseSpace>
      <S.ActionWrapper className='actions'>
        {
          showRead && (
            <S.ActionButton type="link"  onClick={() =>  {
              if (onRead) onRead(id);
            }}>
              <LikeFilled />
            </S.ActionButton>
          )
        }
        {
          showDelete && (
            <S.ActionButton type="link" onClick={() => {
              if (onDelete) onDelete(id);
            }}>
              <DeleteFilled />
            </S.ActionButton>
          )
        }
      </S.ActionWrapper>
    </S.SpaceWrapper>
  );
};
